import { Control, FieldValues } from 'react-hook-form';
import { TextField } from 'admin/company/components/ManageTeam/Forms/fields/TextField';
import { TextareaField } from 'admin/company/components/ManageTeam/Forms/fields/TextareaField';
import { UploadImage } from 'admin/company/components/ManageTeam/Forms/fields/UploadImage';
import { FieldsGroup } from 'admin/company/components/ManageTeam/Forms/styles';
import {
  firstName,
  homeTown,
  lastName,
  profileBio,
  profileImage,
  stateOrCountry,
} from 'admin/company/constants/usersConstants';
import { GridContainer } from 'common/alchemyComponents/GridHelpers';

interface ProfileFormProps {
  control: Control<FieldValues>;
  requiredFields: string[];
  /** Invitations collect the name only; the invited user fills in the rest later. */
  nameOnly?: boolean;
  /** Companies with integrated employees manage location outside of Agent Connect. */
  hideLocation?: boolean;
  /** Hometown, state or country and bio are only used by the feedback product. */
  showDetails?: boolean;
  /** Company-configured guidance shown alongside the bio field. */
  bioGuidance?: string;
}

export const ProfileForm = ({
  control,
  requiredFields,
  nameOnly = false,
  hideLocation = false,
  showDetails = true,
  bioGuidance,
}: ProfileFormProps) => {
  const showProfileDetails = !nameOnly && showDetails;

  return (
    <FieldsGroup>
      {!nameOnly && (
        <UploadImage
          control={control}
          required={requiredFields.includes(profileImage.key)}
          buttonText="Upload Image"
          name={profileImage.key}
        />
      )}

      <TextField
        control={control}
        required={requiredFields.includes(firstName.key)}
        label={firstName.label}
        placeholder={firstName.placeholder}
        name={firstName.key}
      />
      <TextField
        control={control}
        required={requiredFields.includes(lastName.key)}
        label={lastName.label}
        placeholder={lastName.placeholder}
        name={lastName.key}
      />

      {showProfileDetails && !hideLocation && (
        <GridContainer columns={2} gap="16px" columnMinWidth="150px" breakpoint="largeDesktop">
          <TextField
            control={control}
            label={homeTown.label}
            placeholder={homeTown.placeholder}
            name={homeTown.key}
          />
          <TextField
            control={control}
            label={stateOrCountry.label}
            placeholder={stateOrCountry.placeholder}
            required={requiredFields.includes(stateOrCountry.key)}
            name={stateOrCountry.key}
          />
        </GridContainer>
      )}

      {showProfileDetails && (
        <TextareaField
          control={control}
          isFullWidth
          required={requiredFields.includes(profileBio.key)}
          label={profileBio.label}
          name={profileBio.key}
          placeholder={profileBio.placeholder}
          tip={bioGuidance}
          maxLength={140}
          minHeight="130px"
        />
      )}
    </FieldsGroup>
  );
};

export default ProfileForm;
